import { render } from "./RequestProTip.vue?vue&type=template&id=e04ccabc&scoped=true"
import script from "./RequestProTip.vue?vue&type=script&lang=js"
export * from "./RequestProTip.vue?vue&type=script&lang=js"

import "./RequestProTip.vue?vue&type=style&index=0&id=e04ccabc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04ccabc"]])

export default __exports__